export default {
  table: {
    columns: {
      service: 'Dienst',
      status: 'Status',
      year: 'Jaar',
      paid_on: 'Betaald op'
    },
    status: {
      paid: 'Betaald',
      open: 'Uitstaand'
    },
    actions: {
      pay: 'Betalen'
    },
    empty: {
      title: 'Je bestelde DGA diensten zullen hier te zien zijn',
      subtitle:
        'Krijg professioneel advies van onze fiscalisten en payroll specialisten. Zo laat jij geen voordelen liggen en bespaar je geld.'
    }
  }
};
